<div class="practice-simulations-container" *ngIf="isTranslationLoaded">
    <h2>{{ 'reportingV2.PRACTICE_SIMULATIONS_LABEL' | transloco }}</h2>
    <span class="simulation-count">
        {{ tableData.length }} {{ 'reportingV2.TOTAL_LABEL' | transloco }}
    </span>
    <div class="table-wrapper">
        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-container">
            <qai-loading [size]="'medium'"></qai-loading>
        </div>

        <!-- Data Loaded State -->
        <qai-table *ngIf="!isLoading" 
            [headers]="headers" [data]="tableData" [initialSortColumn]="initialSortColumn" [initialSortDirection]="initialSortDirection" 
            [pageSize]="pageSize" [currentPage]="currentPage"  [noDataMessage]="'reportingV2.NO_SIMULATIONS_FOUND_LABEL' | transloco"
            (rowClick)="onTableRowClick($event)">
        </qai-table>
    </div>
</div>